module.exports = __webpack_public_path__ + "img/award-b.610fe428.png";